module.exports = __webpack_public_path__ + "media/images/icons/email_v2-82dd773360016764077b221914b2e642.svg";